export enum IMenuItemIcon {
  Form = "menu_form.png",
  Folder = "menu_folder.png",
  Workflow = "menu_workflow.png",
  Parameter = "menu_parameter.png",
  WorkQueue = "./icons/work-queue.svg",
  Chat = "./icons/chat.svg"
}